(function () {
  function equalizeArticleTitleHeights(sectionEl) {
    var titles = sectionEl.querySelectorAll('.article-title');
    if (titles.length < 2) return;

    // Reset so we can measure natural heights
    titles.forEach(function (t) { t.style.minHeight = ''; });

    var maxHeight = 0;
    titles.forEach(function (t) {
      maxHeight = Math.max(maxHeight, t.offsetHeight);
    });

    titles.forEach(function (t) { t.style.minHeight = maxHeight + 'px'; });
  }

  function initAll() {
    document.querySelectorAll('[data-equalize-titles]').forEach(function (section) {
      equalizeArticleTitleHeights(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
    window.addEventListener('resize', initAll);
  });

  // Re-run once custom fonts (Typekit) finish loading, as they affect text height
  if (document.fonts) {
    document.fonts.ready.then(initAll);
  }
})();
